import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch shipments with accident flag
 * @param {Object} filter shipmentAccidents filters
 * @param {Number} filter.page page
 * @param {Number} filter.size list size per page
 * @param {String} filter.sort list sort
 * @param {String} filter.status shipmentAccident proccess status ie: 'NEW', 'INPROCESS, 'RESOLVED'
 */
const fetchList = async function (filter) {
  try {
    filter = {
      ...filter,
      page: filter.page - 1
    }
    const res = await axios.get(urls.shipmentAccidentList + '?' + querystring.stringify(filter))
    console.log('TCL: res', res)
    return res.data
  } catch (error) {
    console.log('TCL: }catch -> error', error)
    return Promise.reject(error)
  }
}

/**
 * fetch shipments with damaged and missing item flag
 * @param {Object} filter filters
 * @param {Number} filter.page page
 * @param {Number} filter.size list size per page
 * @param {String} filter.sort list sort
 * @param {String} filter.status damaged and missing item proccess status ie: 'NEW', 'INPROCESS, 'RESOLVED'
 */
const fetchDamagedAndMissingList = async function (filter) {
  try {
    filter = {
      ...filter,
      page: filter.page - 1
    }
    const res = await axios.get(urls.damagedAndMissingList + '?' + querystring.stringify(filter))
    console.log('TCL: res', res)
    return res.data
  } catch (error) {
    console.log('TCL: }catch -> error', error)
    return Promise.reject(error)
  }
}

/**
 * fetch damaged and missing detail from shipment
 * @param {Number} orderId shipment/order id
 */
const fetchDamagedAndMissingDetail = async function (orderId) {
  try {
    let data = {
      shipmentId: orderId
    }
    let res = await axios.get(urls.damagedAndMissingDetail + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * process a shipment accident
 * @param {Number} shipmentGroupId shipment ggroup id to process
 */
const processProblem = async function (shipmentGroupId) {
  try {
    const res = await axios.put(urls.processProblem, { shipmentGroupId })
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * resolve a shipment accident
 * @param {Number} shipmentId shipment id to process
 * @param {String} reason problem reason retrieved from sipment Object
 * @param {String} resolveNote note to resolve the problem
 * @param {String} status next order status if cancel => "cancel" or empty string for else
 */
const resolveProblem = async function (shipmentGroupId, reason, resolveNote, status) {
  try {
    let data = {
      shipmentGroupId,
      reason,
      note: resolveNote,
      resolveStatus: status,
    }
    console.log('file: shippingProblem.js ~ line 90 ~ resolveProblem ~ data', data)
    const res = await axios.post(urls.resolveProblem, data)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * get new pickup location for new shipment to continue
 * @param {Number} shipmentId new shipment to continue
 * @param {String} referenceShipmentNo shipment problem to continue from
 */
const shipmentProblemLocation = async function (shipmentId, referenceShipmentNo) {
  try {
    let data = {
      currentId: shipmentId,
      referenceNo: referenceShipmentNo,
    }
    console.log('TCL: data', data)
    let res = await axios.get(urls.shipmentProblemLastLoc + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch shipment problem detail
 * @param {Number} shipmentGroupId shipmentGroupId id
 */
const shipmentProblemDetail = async function (shipmentGroupId) {
  try {
    let data = {
      shipmentGroupId
    }
    let res = await axios.get(urls.shipmentProblem + '?' + querystring.stringify(data))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

const newAccidentCount = async function () {
  try {
    let res = await axios.get(urls.newAccidentCount)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchList,
  fetchDamagedAndMissingList,
  fetchDamagedAndMissingDetail,
  processProblem,
  resolveProblem,
  shipmentProblemLocation,
  newAccidentCount,
  shipmentProblemDetail,
}
